import { MouseEvent } from 'react';
import { Button, ButtonHtmlTypes, ButtonTypes, ColorStyles } from '@aidexa/open-ds';
import { refreshHttpOnlyCookie } from '@pages/api/auth';
import { Props } from './Button.models';
import styles from './Buttons.module.scss';

export enum ButtonType {
  NextButton = 'NextButton',
  BackButton = 'BackButton',
  ContinueButton = 'ContinueButton'
}

const Buttons = ({
  buttonType,
  disabled,
  fullHeight,
  fullWidth,
  label,
  onClick,
  role,
  className,
  dataTestId = '',
  htmlType = ButtonHtmlTypes.Submit
}: Props) => {
  const activeButton = () => {
    switch (buttonType) {
      case ButtonType.NextButton:
        return `${styles.nextButtonActiveColor} primary-button`;
      case ButtonType.BackButton:
        return `${styles.backButtonActiveColor} secondary-button`;
      case ButtonType.ContinueButton:
        return `${styles.continueButtonActiveColor} primary-button`;
      default:
        return `${styles.backButtonActiveColor} secondary-button`;
    }
  };

  const disabledButton = () => {
    switch (buttonType) {
      case ButtonType.NextButton:
        return `${styles.nextButtonDisabledColor} primary-button__disabled`;
      case ButtonType.BackButton:
        return `${styles.backButtonDisabledColor} secondary-button__disabled`;
      default:
        return `${styles.backButtonDisabledColor} secondary-button__disabled`;
    }
  };

  const handleOnClick = async (e: MouseEvent<HTMLElement>) => {
    (e.target as HTMLButtonElement).blur();
    if (onClick) {
      onClick(e);
    }

    try {
      await refreshHttpOnlyCookie();
    } catch (err) {
      console.error(err);
    }
  };

  const buttonDataTestId = dataTestId ? `${dataTestId}-button` : '';

  return (
    <div
      data-testid={dataTestId}
      role={role}
      className={`
      buttonComponent
      ${styles.buttonWrapper}
      ${disabled ? disabledButton() : activeButton()}
      ${fullWidth ? styles.fullWidth : ''}
      ${fullHeight ? styles.fullHeight : ''}
      ${className || ''}
      
    `}
    >
      <Button
        testId={buttonDataTestId}
        label={label ? label : ''}
        type={ButtonTypes.Primary}
        htmlType={htmlType}
        colorStyle={ColorStyles.Basic5}
        className={`special ${fullWidth ? styles.fullWidth : ''}`}
        disabled={disabled}
        onClick={handleOnClick}
      />
    </div>
  );
};

export default Buttons;
